import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { RouteConstants } from '@/features/router/RouteConstants';
import { SmsCampaign } from '../Sms/Campaigns/Create/SmsCampaign';

export const CampaignsSmsEditFlowV2: FC = () => {
  const history = useHistory();
  const { campaignId } = useParams<{ campaignId: string }>();

  const handleExitToList = () => {
    history.push(RouteConstants.smsCampaigns);
  };

  return <SmsCampaign mode='edit' campaignId={campaignId} onExitToList={handleExitToList} />;
};
